export default "__VITE_ASSET__B6Hj2v2m__"